import { render, staticRenderFns } from "./WikiPageHistoryList.vue?vue&type=template&id=ae69c140"
import script from "./WikiPageHistoryList.vue?vue&type=script&lang=ts"
export * from "./WikiPageHistoryList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports